import { Tooltip, TooltipProps } from '@mui/material';
import React from 'react';
import { useTooltipOpenChange } from '../../../utils/customHooks';

export type DesktopTooltipProps<AnchorProps> = Omit<TooltipProps, 'children' | 'title'> & {
	onOpen?: () => void;
	onClose?: () => void;
	AnchorComponent: React.ComponentType<AnchorProps>;
	AnchorComponentProps?: AnchorProps;
	children: React.ReactNode;
};

export function DesktopTooltip<AnchorProps>(props: DesktopTooltipProps<AnchorProps>) {
	const { classes, onOpen, onClose, AnchorComponent, AnchorComponentProps, children, ...other } = props;

	const { onOpen: onOpenFixed, onClose: onCloseFixed } = useTooltipOpenChange({
		onOpen: onOpen,
		onClose: onClose
	});

	return (
		<Tooltip
			{...other}
			onOpen={onOpenFixed}
			onClose={onCloseFixed}
			title={children}
			arrow>
			<AnchorComponent
				{...AnchorComponentProps} />
		</Tooltip>
	);
}
